  // Generate image URL from imageFileId
  export const getImageUrl = (imageFileId: string | undefined | null) => {
    if(!imageFileId) return
    return `https://api.pathadvisor.pl/api/v1/files/${imageFileId}`
  }